{
  "collapse": "Contraer",
  "expand": "Expandir"
}
